exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#333",
	"menuActiveText": "#ffa412",
	"subMenuActiveText": "#ffa412",
	"menuBg": "#fff",
	"menuHover": "rgba(240,242,245,.7)",
	"subMenuBg": "rgba(255,164,18,.1)",
	"subMenuHover": "#fff",
	"sideBarWidth": "230px"
};